import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { GetCollectionQuery, PriceRange } from '../../common/gql/graphql';
import { FacetValueIdPair, FacetWithValues } from '../../providers/facet-filter.service';
import { FormatPricePipe } from '../../../shared/pipes/format-price.pipe';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'kb-active-filters',
    templateUrl: './active-filters.component.html',
    styleUrls: ['./active-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        RouterLink,
        NgFor,
        FormatPricePipe,
    ],
})
export class ActiveFiltersComponent implements OnChanges {
    @Input() groupedActiveFacetValueIds: string[][] = [];
    @Input() activeFacetValueIds: FacetValueIdPair[] = [];
    @Input() facets: FacetWithValues[] | null;
    @Input() collection: GetCollectionQuery['collection'] | null;
    @Input() prices: Partial<PriceRange> | undefined | null;
    private allFacetValues = new Map<
        string,
        { id: string; name: string; facetId: string; facetName: string }
    >();

    constructor(private route: ActivatedRoute, private router: Router) {}

    ngOnChanges() {
        for (const facet of this.facets ?? []) {
            for (const facetValue of facet.values) {
                if (!this.allFacetValues.get(facetValue.id)) {
                    this.allFacetValues.set(facetValue.id, {
                        id: facetValue.id,
                        name: facetValue.name,
                        facetId: facet.id,
                        facetName: facet.name,
                    });
                }
            }
        }
    }

    getFacetValue(id: string): { id: string; name: string; facetId: string; facetName: string } | undefined {
        return this.allFacetValues.get(id);
    }

    toggleFacetValueId(facetId: string, valueId: string): string[] {
        const pair = `${facetId}-${valueId}` as const;
        const existing = this.activeFacetValueIds;
        return existing.includes(pair) ? existing.filter((x) => x !== pair) : existing.concat(pair);
    }

    removePriceFilter() {
        this.router.navigate(['./'], {
            queryParamsHandling: 'merge',
            queryParams: { min: undefined, max: undefined },
            relativeTo: this.route,
        });
    }
}
